@import 'common/component';

:host {
  display: block;
}

:host(:focus-visible) {
  outline: none;
}

.menu__item {
  display: flex;
  align-items: center;
  min-width: $component-min-width;
  min-height: 3.6rem;
  padding: 0.8rem 1.6rem;
  cursor: pointer;

  &:hover {
    background: var(--o2-menu-item-background-hover, mix($black, $white, $opacity-hover * 1%));
  }

  &--selected {
    background: $background-main-secondary;
  }

  &--active {
    background: $background-main-secondary;
  }

  &--disabled {
    opacity: var(--o2-opacity-disabled, #{$opacity-disabled * 1%});
    cursor: not-allowed;
  }
}

.menu__icon {
  margin-right: 0.8rem;
}

.menu__content, .menu__text {
  font-size: 1.4rem;
  line-height: 1.3;
  color: $text-main-primary;
  flex: 1;

  @include text-truncate();
}
